export class NxiContextResponse {
    inputValue: string;
    hashValue: string;
}
